import { NavLink, Outlet } from 'react-router-dom';
import { SHOW_SUBGROVES } from '../lib/flags';

const SUB_TABS = [
  // Each reads a subgrove's data: an ID to ask for, or a query result to open.
  ...(SHOW_SUBGROVES
    ? [
        { to: 'vrpc', label: 'Verifiable RPC' },
        { to: 'viewer', label: 'Proof Viewer' },
      ]
    : []),
  { to: 'inspector', label: 'Proof Inspector' },
  { to: 'helios', label: 'Ethereum Light Client' },
  { to: 'events-hash', label: 'Events Hash' },
];

export function VerifyPanel() {
  return (
    <>
      <nav className="sub-tabs" role="tablist">
        {SUB_TABS.map((t) => (
          <NavLink
            key={t.to}
            to={t.to}
            preventScrollReset
            className={({ isActive }) => (isActive ? 'sub-tab sub-tab-active' : 'sub-tab')}
          >
            {t.label}
          </NavLink>
        ))}
      </nav>
      <Outlet />
    </>
  );
}
